// PD-01: Captain removed — label suggestions were Captain Tasks feature, now disabled
import { ref } from 'vue';

export function useLabelSuggestions() {
  const isLabelSuggestionFeatureEnabled = ref(false);
  const labelSuggestions = ref(null);

  const getLabelSuggestions = () => null;

  return {
    isLabelSuggestionFeatureEnabled,
    labelSuggestions,
    getLabelSuggestions,
  };
}
